export enum Routes {
  Home = "Home",
  TransferNavigator = "TransferNavigator",
  TilesHome = "TilesHome",
  Loading = "Loading",
  AuthStack = "AuthStack",
  Auth = "Auth",
  Login = "Login",
  Register = "Register",
  FormCompleted = "FormCompleted",
  Onboarding = "Onboarding",
  OnboardingSuccess = "OnboardingSuccess",
  OnboardingFile = "OnboardingFile",
  OnboardingFileSubmitted = "OnboardingFileSubmitted",
  AccountsTab = "AccountsTab",
  ProductsTab = "ProductsTab",
  CardsTab = "CardsTab",
  PayBillTab = "PayBillTab",
  TransferTab = "TransferTab",
  TransferSelection = "TransferSelection",
  SourceAccountSelection = "SourceAccountSelection",
  DestinationAccountOrRecipient = "DestinationAccountOrRecipient",
  OpenLoopTransfer = "OpenLoopTransfer",
  OpenLoopTransferNavbar = "OpenLoopTransferNavbar",
  OpenLoopSummary = "OpenloopSummary",
  MoreTab = "MoreTab",
  AccountDetails = "AccountDetails",
  ClientInformation = "ClientInformation",
  KycUnchangedConfirmation = "KycUnchangedConfirmation",
  Recipients = "Recipients",
  AddBeneficiary = "AddBeneficiary",
  AddExternalAccount = "AddExternalAccount",
  EditRecipient = "EditRecipient",
  BeneficiaryDetail = "BeneficiaryDetail",
  BeneficiariesTransferModeSelection = "BeneficiariesTransferModeSelection",
  SearchBank = "SearchBank",
  Otp = "Otp",
  Cards = "Cards",
  NewCards = "NewCards",
  AcceptorNavigator = "AcceptorNavigator",
  ConnectedAcceptorNavigator = "ConnectedAcceptorNavigator",
  AcceptorTabNavigator = "AcceptorTabNavigator",
  AcceptorSearch = "AcceptorSearch",
  AcceptorList = "AcceptorList",
  AcceptorMapRedirect = "AcceptorMapRedirect",
  Transfer = "Transfer",
  TransferRecipients = "TransferRecipients",
  SimpleTransfer = "SimpleTransfer",
  TransferAmountSelection = "TransferAmountSelection",
  TransactionConfirmation = "TransactionConfirmation",
  PincodeConfirmation = "PincodeConfirmation",
  AccountBlocked = "AccountBlocked",
  TransferSummary = "TransferSummary",
  PayBill = "PayBill",
  BillForm = "BillForm",
  BillReferences = "BillReferences",
  TransactionCodes = "TransactionCodes",
  CodeEntry = "CodeEntry",
  TransactionCodeSummary = "TransactionCodeSummary",
  AccountStatementsNavigator = "AccountStatementsNavigator",
  AccountStatements = "AccountStatements",
  TaxStatements = "TaxStatements",
  EditRib = "EditRib",
  FeesStatements = "FeesStatements",
  Settings = "Settings",
  Security = "Security",
  DesignateTrustedDevice = "DesignateTrustedDevice",
  DesignateTrustedDeviceSuccessScreen = "DesignateTrustedDeviceSuccessScreen",
  DesignateTrustedDeviceErrorScreen = "DesignateTrustedDeviceErrorScreen",
  DisassociateTrustedDevice = "DisassociateTrustedDevice",
  DisassociateTrustedDeviceSuccessScreen = "DisassociateTrustedDeviceSuccessScreen",
  DisassociateTrustedDeviceErrorScreen = "DisassociateTrustedDeviceErrorScreen",
  PincodeChange = "PincodeChange",
  EULA = "EULA",
  Privacy = "Privacy",
  OtpAuth = "OtpAuth",
  CashTransfer = "CashTransfer",
  TransactionSummary = "TransactionSummary",
  ContactSupport = "ContactSupport",
  AccountTransaction = "AccountTransaction",
  ExternalLoansManagement = "ExternalLoansManagement",
  PaymentForm = "PaymentForm",
  ExternalUbble = "ExternalUbble",
  Result = "Result",
  ClientStatusResult = "ClientStatusResult",
  ActivateCard = "ActivateCard",
  CreateCard = "CreateCard",
  RefabricateCard = "RefabricateCard",
  UpdateCardPincode = "UpdateCardPincode",
  RechargeAccount = "RechargeAccount",
  AccountSelection = "AccountSelection",
  RechargeByCard = "RechargeByCard",
  RechargeBankToWallet = "RechargeBankToWallet",
  RechargeSummary = "RechargeSummary",
  OpposeCard = "OpposeCard",
  AccountDelete = "AccountDelete",
  QRCode = "QRCode",
  QRCodeInput = "QRCodeInput",
  QRCodeResult = "QRCodeResult",
  QRCodeParameters = "QRCodeParameters",
  QRCodeDisplay = "QRCodeDisplay",
  QrCodesLibrary = "QrCodesLibrary",
  QRCodeFocus = "QRCodeFocus",
  AuthorizationHoldsList = "AuthorizationHoldsList",
  JustifyTransaction = "JustifyTransaction",
  ExpenseEditDetails = "ExpenseEditDetails",
  CardOutstandings = "CardOutstandings",
  UpdateCardOutstanding = "UpdateCardOutstanding",
  DebugNavigator = "DebugNavigator",
  PartyAuthenticationList = "PartyAuthenticationList",
  PartyAuthentication = "PartyAuthentication",
  PartyAuthenticationAccepted = "PartyAuthenticationAccepted",
  PartyAuthenticationRefused = "PartyAuthenticationRefused",
  PartyAuthenticationFailed = "PartyAuthenticationFailed",
  PartyAuthenticationCancelled = "PartyAuthenticationCancelled",
  PartyAuthenticationBlocked = "PartyAuthenticationBlocked",
  AskCredit = "AskCredit",
  CreditSimulation = "CreditSimulation",
  CreditAdditionnalForm = "CreditAdditionnalForm",
  CreditResponse = "CreditResponse",
  ManageCredits = "ManageCredits",
  CreditDetails = "CreditDetails",
  BillIssuerNavigator = "BillIssuerNavigator",
  MarchantBillIssuerNavigator = "MarchantBillIssuerNavigator",
  MobileBillIssuerNavigator = "MobileBillIssuerNavigator",
  CodeConfirmationBillIssuerNavigator = "CodeConfirmationBillIssuerNavigator",
  CodeConfirmationBillIssuer = "CodeConfirmationBillIssuer",
  InvestmentBillIssuerNavigator = "InvestmentBillIssuerNavigator",
  InvestmentBillIssuer = "InvestmentBillIssuer",
  TransferBillIssuerNavigator = "TransferBillIssuerNavigator",
  TransferBillIssuer = "TransferBillIssuer",
  RechargeNavigator = "RechargeNavigator",
  TransferBankNavigator = "TransferBankNavigator",
  BillIssuerByType = "BillIssuerByType",
  Beneficiaries = "Beneficiaries",
  AccountPendingVerification = "AccountPendingVerification",
  WithdrawalNavigator = "WithdrawalNavigator",
  ErrorScreen = "ErrorScreen",
  RefundTransaction = "RefundTransactionScreen",
  UpcomingTransfers = "UpcomingTransfers",
  EditUpcomingTransfer = "EditUpcomingTransfer",
  UbbleRedirectionSuccess = "UbbleRedirectionSuccess",
  Mandates = "Mandates",
}
